import { Tabs as MuiTabs, Tab as MuiTab } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { drawerWidth } from '../AppLayout.constants';

export const useStyles = makeStyles(theme => ({
  drawerPaper: {
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    backgroundColor: theme.palette.background.paper,
    borderRight: 'none',
    '&:hover': {
      boxShadow: '0px 2px 16px rgba(0, 24, 26, 0.12)'
    }
  },
  drawerPaperClose: {
    position: 'relative',
    overflowX: 'hidden',
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7)
    }
  }
}));

export const Tabs = withStyles({
  indicator: {
    left: 0,
    width: 3
  }
})(MuiTabs);

// Change out the padding style when justin provides the changes.
export const Tab = withStyles(theme => ({
  root: {
    minWidth: 0,
    padding: '6px 12px 6px 20px',
    '&:hover': {
      backgroundColor: '#F8FCFC'
    },
    width: '100%'
  },
  labelIcon: {
    minHeight: 52
  },
  selected: {
    color: theme.palette.primary.main,
    backgroundColor: '#F8FCFC'
  },
  wrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start'
  }
}))(MuiTab);
